import { Injectable } from '@angular/core';
import { CategoriaVeiculo } from '@tivic-team/manager-ts/dist/fta/entities/categoria-veiculo.entity';
import { CategoriaVeiculoController } from 'app/controllers/fta/categoria-veiculo.controller';
import { LoaderService } from '../loader.service';
import { CategoriaVeiculoSearch } from './categoria-veiculo.search';


@Injectable()
export class CategoriaVeiculoService {

  constructor(
    private _categoriaVeiculoController: CategoriaVeiculoController,
    private _loaderService: LoaderService
  ) {}


  async getAll(isLoading:boolean=true ):Promise<CategoriaVeiculo[]>{
    try{
      if(isLoading) this._loaderService.show();
      return await this._categoriaVeiculoController.find().finally(() => {if (isLoading) this._loaderService.hide()});
    }catch(error){return [];}
  }  

  async get(cdCategoria:number):Promise<CategoriaVeiculo>{
    this._loaderService.show();
    return this._categoriaVeiculoController.get(cdCategoria).finally(() => this._loaderService.hide());
  }

  async find(categoriaVeiculoSearch?: CategoriaVeiculoSearch):Promise<CategoriaVeiculo[]>{
    this._loaderService.show;
    try{
      return await this._categoriaVeiculoController.find((categoriaVeiculoSearch && categoriaVeiculoSearch.getFilters()) || null)
        .finally(() => this._loaderService.hide());
    }catch(error){
      this._loaderService.hide()
      console.log(error);
      return [];
    }
  }

  async save(categoriaVeiculo: CategoriaVeiculo): Promise<CategoriaVeiculo>{
      console.log('Loading Categoria Veiculo Service...');
      this._loaderService.show();
      if(categoriaVeiculo.cdCategoria && categoriaVeiculo.cdCategoria > 0){
        console.log('update');
        return this._categoriaVeiculoController.update(categoriaVeiculo).finally(() => this._loaderService.hide());
      }else{
        console.log('Create');
        return this._categoriaVeiculoController.create(categoriaVeiculo).finally(() => this._loaderService.hide());
      }
  }
}
